<template>
    <div>
        <p class="block mb-2" :id="`field_${field.id}`">{{field.label}}<span class="text-bold inline-block ml-2" v-if="field.isRequired" title="This field is required" aria-hidden="true">*</span></p>
        <div class="inline-flex flex-row flex-wrap border border-solid rounded overflow-hidden">
            <template v-for="(choice, choice_key) in field.choices">
            <label
                role="switch"
                :aria-checked="$store.state.data[field.id] == choice.value"
                :key="choice_key"
                :class="[
                    $store.state.data[field.id] == choice.value ? `${$store.state.configs.button} ${$store.state.configs.button_text} font-bold` : '',
                    choice_key != Object.keys(field.choices).length - 1 ? 'border-r' : ''
                ]"
                class="select-none py-2 px-4 border-solid cursor-pointer m-0 font-medium"
                tabindex="0"
                @keypress.prevent="e => {
                    if([32,13].includes(e.keyCode)) e.target.click();
                }"
            >
                {{choice.text}}
                <input 
                    :key="choice_key"
                    :required="field.isRequired" 
                    :name="field.id" 
                    v-model="fields[field.id]"
                    type="radio" 
                    class="hidden"
                    v-show="false"
                    :value="choice.value"
                    :id="`field_${field.id}_${choice_key}`"
                >
            </label>
            
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ["field","fields"]
};
</script>